import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ServerService } from '../../../../service/server/server.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SaleFactorDetaileComponent } from '../../../sale-factor-detaile/sale-factor-detaile.component';
import { MatTableDataSource } from '@angular/material/table';
import { SalePrintComponent } from '../../../sale-print/sale-print.component';
import { SaleSearchComponent } from '../../../sale-search/sale-search.component';
import { SaleCommentComponent } from '../../../sale-comment/sale-comment.component';
import { SalePaymentDetaileComponent } from '../../../sale-payments/sale-payment-detaile/sale-payment-detaile.component';
import { SalePaymentsList2Component } from '../../../sale-payments/sale-payments-list2/sale-payments-list2.component'
import { WharehouseExit2Component } from '../../../../system/wharehouse/wharehouse-exit2/wharehouse-exit2.component';

@Component({
  selector: 'app-sale-lsf-pages',
  templateUrl: './sale-lsf-pages.component.html',
  styleUrls: ['./sale-lsf-pages.component.css']
})
export class SaleLsfPagesComponent implements OnInit {
  public isOnline: boolean;
  public username: string = JSON.parse(<any>localStorage.getItem('username'));
  public fname: string; public lname: string;
  public server: string = this.serverService.get_server();
  public site: string = this.serverService.get_site();
  public lang: any;
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public task_type: number;
  public confirm_delete: boolean;
  public count_total: any = "--"; public page_number_first: any = "--"; public page_number_second: any = "--"; public page: number = 1;
  public type: number; public type_search: number;
  public type_send: number;
  public waiting_excell: number = 1;
  public show_excel: boolean = false;
  public export_code: number;
  year: number;
  plan: number;
  public document: number;
  list_forms: any = [];
  list_floor: any = [];
  search_array: any = [];
  user_sms: number;
  sum: number;
  order_id: number | undefined;
  sum_payment: number;
  sum_percent: number;
  price_all_m2: number;
  sum_price_all: number;
  @ViewChild('profile_user_modal') profile_user_modal: any;
  search_all: string | undefined;
  //******************************************* */
  dataSource;
  public mat_table_selectedRow: any;
  public mat_table_hoverRow: any;
  displayedColumns = ['row', 'customer', 'code', 'price', 'bana', 'price_all', 'price_all_m2', 'percent', 'price_final', 'payment', 'date', 'creator', 'status', 'id', 'operation'];
  //******************************************* */
  @ViewChild('myModal') myModal: any;
  @ViewChild('modal_price') modal_price: any;
  shop_sazeh_price: number;
  shop_sazeh_price_price_lsf1: number;
  shop_sazeh_price_price_lsf2: number;
  shop_sazeh_price_price_lsf3: number;
  public obj = {};
  public data = {};
  public list_record: any = [];
  public list_status: any = [];
  list_price: any = [];
  id: number;
  public pre_status: boolean; public next_status: boolean;
  //******************************************************************************currency
  public number1: number;
  public percent: number;
  public user_fname: string;
  public user_cellphone: number;
  public user_username: string;

  public type_user: number;
  public code: number;
  public limit_product: number;
  public product: number = 1;
  public status: number;
  public disable_status1: boolean;
  public task: number;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));
  public list_process: any = [];
  user_id: number;
  service_id: number;


  constructor(public router: Router, public activatedRoute: ActivatedRoute, public serverService: ServerService
    , public dialog: MatDialog, private matSnackBar: MatSnackBar) {
  }//end constructor




  ngOnInit() {
    if (this.user_info) this.user_id = this.user_info.user_id;
    this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.code = params['code'];
        this.product = params['type'];
        this.service_id = params['id'];
        this.search_array = [];
        this.search_all = '';
        this.check_access(4, 1, '', 1, 1);
        //this.recieve_process();
        if (this.product == 1) { this.limit_product = 1; }
        else { this.limit_product = 2; }
        this.serverService.send_shop_process({ product: this.product, service_id: this.service_id });
      }
    )

    this.isOnline = navigator.onLine;
    this.lang = JSON.parse(<any>localStorage.getItem('lang'));
    this.fname = JSON.parse(<any>localStorage.getItem('fname'));
    //this.recieve_process();

  }//ngOnInit

  /*
  recieve_process() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 68, id: this.product, user_id: this.user_id }).subscribe(
      (res) => {
        this.list_process = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_process.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 2, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_process
  */

  check_access(type_task: number, page: number, id: any, excel: number, loading: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    if (loading == 1) this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.service_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            if (type_task == 3) {
              this.delete(id);
            }
            if (type_task == 4) { this.load_data(page, 1, 1, loading); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  open_modal_price() {
    this.modal_price.open();
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    var obj = {
      address: 180,
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        this.list_price = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.shop_sazeh_price = res['result'][0].shop_sazeh_price;
            this.shop_sazeh_price_price_lsf1 = res['result'][1].shop_sazeh_price_price_lsf1;
            this.shop_sazeh_price_price_lsf2 = res['result'][2].shop_sazeh_price_price_lsf2;
            this.shop_sazeh_price_price_lsf3 = res['result'][3].shop_sazeh_price_price_lsf3;
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  get_menu1(id: number) {
    this.order_id = id;
  }

  update_price() {
    if (this.serverService.check_internet()['status'] == false) {
      this.err_internet_validation = true;
      this.err_internet_text = this.serverService.check_internet()['title'];
      return;
    }//end if
    else { this.err_internet_validation = false; }
    this.loading = true;
    var obj = {
      'address': 181, "username": this.username
      , 'shop_sazeh_price': this.shop_sazeh_price
      , 'shop_sazeh_price_price_lsf1': this.shop_sazeh_price_price_lsf1
      , 'shop_sazeh_price_price_lsf2': this.shop_sazeh_price_price_lsf2
      , 'shop_sazeh_price_price_lsf3': this.shop_sazeh_price_price_lsf3

    };
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.modal_price.close();
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در ذخیره";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    );
  }//end update_price

  load_data2() {
    this.search_all = "";
    this.search_array = "";
    this.load_data(1, 1, 1, 1);
  }

  load_data(page, task, excel, loading) {
    if (this.check_internet() == false) { return; }
    if (loading == 1) this.loading = true;
    if (page == 1) { this.page = 1; }
    if (page == 2) { this.page = this.page + 1; }
    if (page == 4) { this.page = Math.ceil(this.count_total / 20); }
    if (page == 3) { this.page = this.page - 1; }
    if (page == 5) { this.page = 1; }
    if (page == 6) { this.page = 1; }
    if (excel == 2) {
      this.waiting_excell = 2;
    }
    if (this.type == 3) {
    }
    if (task != this.task) { this.page = page; }
    //87
    this.obj = {
      "lang": this.lang, 'address': 1524, 'year': this.year, user_id: this.user_id, "page": this.page, 'type': this.type, 'code': this.code, 'task': task
      , 'type_product': this.product, 'excel': excel
      , 'search_array': this.search_array, search_all: this.search_all
    };
    this.subscription = this.serverService.post_address(this.server, 'new_address', this.obj).subscribe(
      (res) => {
        this.data = res;
        if (this.data['status'] == 1) {
          if (excel == 1) {
            this.list_record = [];
            for (var i = 0; i < this.data['num']; i++) {
              this.list_record.push(this.data['result'][i]);
            }//end for 
            //************ */
            this.count_total = res['count'];
            this.sum = res['sum'];
            this.sum_percent = res['sum_percent'];
            this.price_all_m2 = res['price_all_m2'];
            this.sum_price_all = res['sum_price_all'];
            this.sum_payment = res['sum_payment']
            this.page_number_first = this.page * 20 - 19;
            this.page_number_second = this.page * 20;
            if (this.page_number_first == 1) { this.pre_status = true; }
            else { this.pre_status = false; }
            if (this.data['num'] < 20) { this.page_number_second = this.count_total; this.next_status = true }//end if
            else { this.next_status = false; }
            this.task = task;
            this.serverService.change_window_resize(2, 'box_process', 0);
            this.serverService.send_services_id(this.code);
            this.recieve_message(false, "", "", 1, "", "");
          }//end excel
          else if (excel == 2) {
            this.show_excel = true;
            this.waiting_excell = 1;
            this.export_code = res['export_code'];
          }//end else if
          this.dataSource = new MatTableDataSource(this.list_record);
          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else 
      }//end res:Response
    ) //ens dubscribe 
  }//end load data  

  //***************************************************************************
  insert() {
    if (this.check_internet() == false) { return; }
    this.loading = true;
    var obj = { address: 1525, "username": this.username, user_id: this.user_id, 'type_product': this.product }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_record.unshift(res['result'][0]);
          this.count_total = this.count_total + 1;
          if (this.count_total > 20) {
            this.list_record.pop();
            this.next_status = false;
          }//end if
          this.id = res['result'][0].pre_factor_lsf_order_id;
          this.dataSource = new MatTableDataSource(this.list_record);
          this.serverService.send_shop_process({ product: this.product, service_id: this.service_id });
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      })
  }//end insert
  //******************************************************************************
  delete(id) {
    this.id = id;
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.confirm_delete = confirm("آيا شما از حدف اطمينان داريد ؟");
    if (this.confirm_delete == true) {
      this.loading = true;
      var obj = {
        address: 1528, "user_id": this.user_id
        , 'id': id, "page": this.page
        , 'type_product': this.product
      };

      this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
        (res) => {
          this.data = res;
          if (this.data['status'] == 1) {
            this.list_record.splice(this.list_record.findIndex((index: any) => index.pre_factor_lsf_order_id == id), 1);
            this.count_total = this.count_total - 1;
            this.err_validation = false;
            this.loading = false;
            this.dataSource = new MatTableDataSource(this.list_record);
            this.serverService.send_shop_process({ product: this.product, service_id: this.service_id });
          }//end if
          else {
            var pe_message = "خطا در حذف";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }//end else
        }//end res:Response
      )//end this.subscription
    }//end this.confirm_delete == true    
  }//end delete
  //******************************************************************************
  back(i, id) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1522, id: id, code: this.code }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.list_record.splice(i, 1);
          this.dataSource.data = this.list_record;
          this.serverService.send_shop_process({ product: this.product, service_id: this.service_id });
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_data
  //*******************************************************************************
  send_sms(user) {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.user_sms = user;
    var confirm = window.confirm("آیا از ارسال نام کاربری و رمز اطمینان دارید ؟ ");
    if (confirm == false) {
      return false;
    } else {
      this.loading = true;
      this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 1518, user: this.user_sms }).subscribe(
        (res: any) => {
          if (res['status'] == 1) {
            var pe_message = "پیامک با موفقیت ارسال شد";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }//end if
          else {
            var pe_message = "خطا در دریافت";
            var pe_action = "بستن";
            this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
          }
        }
      )

    }
  }

  open_payments(id: number) {
    this.dialog.open(SalePaymentsList2Component, {
      width: '60rem',
      height: 'auto',
      data: { invoice: id }
    })
  }
  //***************************************************************************
  change_task2(i, id) {
    const dialogRef = this.dialog.open(SaleFactorDetaileComponent, {
      width: '80rem',
      height: 'auto',
      disableClose: true,
      data: { id: id, code: this.code, product: this.product, i: i, service_id: this.service_id }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          if (result.type == 1 || result.type == 2) {
            this.list_record[i].bana_all = result.bana_all;
            this.list_record[i].pre_factor_lsf_order_price = result.pre_factor_lsf_order_price;
            this.list_record[i].price_all_without_discount = result.price_all_without_discount;
            this.list_record[i].discount = result.discount;
            this.list_record[i].pre_factor_lsf_order_percent = result.pre_factor_lsf_order_percent;
            this.list_record[i].pre_factor_lsf_order_price_all_without_discount = result.pre_factor_lsf_order_price_all_without_discount;
            this.list_record[i].pre_factor_lsf_order_price_final = result.pre_factor_lsf_order_price_final;
            this.list_record[i].pre_factor_lsf_order_meter = result.pre_factor_lsf_order_meter;
            this.list_record[i].user_title = result.user_title;
            this.user_sms = result.requester_id;
            this.list_record[i].pre_factor_lsf_order_price_all = result.price_all;
            this.list_record[i].pre_factor_lsf_order_price_all_m2 = result.price_all_m2;
            this.list_record[i].pre_factor_lsf_order_percent = result.percent;
            this.list_record[i].pre_factor_lsf_order_price_final = result.price_final;
            this.list_record[i].bed = result.bed;
            this.list_record[i].best = result.best;

          }
          else if (result.type == 3) {
            this.list_record.splice(i, 1);
          }
          this.dataSource.data = this.list_record;
        }
        this.serverService.send_shop_process({ product: this.product, service_id: this.service_id });
      }
    )
  }


  open_comment(id) {
    this.dialog.open(SaleCommentComponent, {
      width: '60rem',
      height: 'auto',
      data: { id: id }
    })
  }

  open_payment(id: number) {
    this.dialog.open(SalePaymentDetaileComponent, {
      width: '60rem',
      height: 'auto',
      data: { id: id, type_task: 1, code: 64 }
    })
  }


  search() {
    const dialogRef = this.dialog.open(SaleSearchComponent, {
      width: '65rem',
      height: 'auto',
      data: { search_array: this.search_array }
    });
    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {

          this.search_array = [];
          this.search_array = res;
          this.load_data(1, 1, res.export_excel, 2);
        }

      }
    )
  }

  open_exit(id: number) {
    this.dialog.open(WharehouseExit2Component, {
      width: '65rem',
      height: 'auto',
      data: { reception_id: id, ref: 'exit', type: 2 }
    })
  }



  open_profile_user(fname, cellphone, username) {
    this.user_fname = fname;
    this.user_cellphone = cellphone;
    this.user_username = username;
    this.profile_user_modal.open();
  }

  get_bg(id) {
    this.id = id;
    localStorage.setItem('PurRequesterOpenComponentLocalId' + this.code, JSON.stringify(id));
  }

  print(id) {
    this.dialog.open(SalePrintComponent, {
      width: '100rem',
      height: 'auto',
      data: { id: id }
    });
  }

  //*******************************************************************************
  ConvertToInt(val) {
    return parseInt(val);
  }

  ConvertToRound(val) {
    return Math.ceil(val);
  }

  check_internet() {
    this.isOnline = navigator.onLine;
    if (this.isOnline == false) {
      this.err_internet_text = "Error in internet connecting";
      this.err_internet_validation = true;
      return false;
    }
    else {
      this.err_internet_validation = false;
    }//end else
  }//end check_internet


  recieve_erorr(err_validation, loading, en_message, pe_message, type) {
    this.err_validation = err_validation;
    if (type == 1) this.loading = loading;
    if (this.lang == 1) { this.err = pe_message; }
    if (this.lang == 2) { this.err = en_message; }
  }//end 


  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }

  ModalClose() {
    this.recieve_erorr(false, false, "", "", 1);
  }

  //*******************************************************************************


}
